interface ConfigDiffViewerProps {
  /** 变更前快照：对象转缩进 JSON 对比；字符串原样对比 */
  left: object | string;
  /** 变更后快照：对象转缩进 JSON 对比；字符串原样对比 */
  right: object | string;
}

const toText = (value: object | string): string =>
  typeof value === 'string' ? value : JSON.stringify(value, null, 2);

function diffStrings(a: string, b: string) {
  const linesA = a.split('\n');
  const linesB = b.split('\n');
  const max = Math.max(linesA.length, linesB.length);
  const out = [];
  for (let i = 0; i < max; i++) {
    const la = linesA[i] ?? '';
    const lb = linesB[i] ?? '';
    if (la === lb) {
      out.push(
        <div key={i} className="diff-line same">
          {la || ' '}
        </div>
      );
    } else {
      out.push(
        <div
          key={`${i}-l`}
          className="diff-line removed"
          style={{ color: 'var(--color-error)', background: 'rgba(248, 81, 73, 0.08)' }}
        >
          - {la}
        </div>
      );
      out.push(
        <div
          key={`${i}-r`}
          className="diff-line added"
          style={{ color: 'var(--color-success)', background: 'rgba(126, 231, 135, 0.08)' }}
        >
          + {lb}
        </div>
      );
    }
  }
  return <>{out}</>;
}

/**
 * before/after 快照行级对比：对象转缩进 JSON 后逐行 diff，
 * 删除行红色、新增行绿色（主题变量，深浅色自适应）。
 * HITL 变更预览（P4）复用本组件渲染快照级差异。
 */
export default function ConfigDiffViewer({ left, right }: ConfigDiffViewerProps) {
  return (
    <div className="config-diff-viewer">
      {diffStrings(toText(left), toText(right))}
    </div>
  );
}
